/* BTR 2026-09-26: video library page (section btr-video-library).
   Filters (shelf tiles, who made it, search), question chips, featured video, and the player.
   The player markup and styles are shared with the product-page videos (btr-product-videos.css);
   here the shop bar links to the product instead of pressing Add to Basket. */
(function () {
  function init() {
    var root = document.querySelector('[data-vl-root]');
    if (!root) return;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-vl-item]'));
    var shelves = Array.prototype.slice.call(root.querySelectorAll('[data-vl-shelf]'));
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-vl-filter]'));
    var byBtns = Array.prototype.slice.call(root.querySelectorAll('[data-vl-by]'));
    var search = root.querySelector('[data-vl-search]');
    var countEl = root.querySelector('[data-vl-count]');
    var emptyEl = root.querySelector('[data-vl-empty]');
    var bar = root.querySelector('[data-vl-bar]');
    var dlg = root.querySelector('.btr-pv-player');
    if (!items.length || !dlg) return;

    var state = { shelf: 'all', by: 'all', q: '' };

    function track(name, params) {
      try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) {}
    }

    // Tile counts
    tiles.forEach(function (t) {
      var id = t.getAttribute('data-vl-filter');
      if (id === 'all') return;
      var n = items.filter(function (it) { return it.getAttribute('data-vl-shelf-of') === id; }).length;
      var el = t.querySelector('[data-vl-tile-count]');
      if (el) el.textContent = n;
      if (!n) t.hidden = true;
    });

    function apply() {
      var words = state.q.toLowerCase().split(/\s+/).filter(Boolean);
      var shown = 0;
      items.forEach(function (it) {
        var ok = (state.shelf === 'all' || it.getAttribute('data-vl-shelf-of') === state.shelf) &&
          (state.by === 'all' || it.getAttribute('data-vl-kind') === state.by) &&
          words.every(function (w) { return (it.getAttribute('data-vl-text') || '').indexOf(w) !== -1; });
        it.hidden = !ok;
        if (ok) shown++;
      });
      shelves.forEach(function (s) { s.hidden = !s.querySelector('[data-vl-item]:not([hidden])'); });
      if (emptyEl) emptyEl.hidden = shown > 0;
      if (countEl) countEl.textContent = shown + (shown === 1 ? ' video' : ' videos');
      tiles.forEach(function (t) { t.setAttribute('aria-pressed', String(t.getAttribute('data-vl-filter') === state.shelf)); });
      byBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-vl-by') === state.by)); });
    }

    function scrollToResults() {
      if (!bar) return;
      var top = bar.getBoundingClientRect().top + window.pageYOffset - 1;
      if (window.pageYOffset < top) {
        var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' });
      }
    }

    function setShelf(id, fromUser) {
      state.shelf = id;
      apply();
      if (fromUser) {
        try { history.replaceState(null, '', id === 'all' ? location.pathname + location.search : '#' + id); } catch (e) {}
        track('btr_video_filter', { shelf: id });
      }
    }

    tiles.forEach(function (t) {
      t.addEventListener('click', function () { setShelf(t.getAttribute('data-vl-filter'), true); scrollToResults(); });
    });
    byBtns.forEach(function (b) {
      b.addEventListener('click', function () { state.by = b.getAttribute('data-vl-by'); apply(); });
    });
    if (search) {
      var timer;
      search.addEventListener('input', function () {
        state.q = search.value.trim();
        apply();
        clearTimeout(timer);
        timer = setTimeout(function () { if (state.q) track('btr_video_search', { search_term: state.q }); }, 1200);
      });
      search.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); scrollToResults(); } });
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-vl-reset]'), function (b) {
      b.addEventListener('click', function () {
        state = { shelf: 'all', by: 'all', q: '' };
        if (search) search.value = '';
        setShelf('all', true);
      });
    });

    // ---- Player ----
    var stage = dlg.querySelector('.btr-pv-player__stage');
    var badge = dlg.querySelector('.btr-pv-player__badge');
    var title = dlg.querySelector('.btr-pv-player__title');
    var meta = dlg.querySelector('.btr-pv-player__meta');
    var text = dlg.querySelector('.btr-pv-player__text');
    var inc = dlg.querySelector('.btr-pv-player__inc');
    var dots = dlg.querySelector('.btr-pv-player__dots');
    var pimg = dlg.querySelector('[data-vl-pimg]');
    var pname = dlg.querySelector('[data-vl-pname]');
    var price = dlg.querySelector('[data-vl-price]');
    var shop = dlg.querySelector('[data-vl-shop]');
    var list = [];
    var current = -1;
    var opener = null;

    function visibleCards() {
      return items.filter(function (it) { return !it.hidden; }).map(function (it) { return it.querySelector('[data-pv-card]'); });
    }

    function stopVideo() {
      var v = stage.querySelector('video');
      if (v) { try { v.pause(); } catch (e) {} }
      stage.innerHTML = '';
    }

    function show(n) {
      n = (n + list.length) % list.length;
      stopVideo();
      current = n;
      var card = list[n];
      var d = card.dataset;
      var tpl = card.parentElement.querySelector('template[data-pv-src]');
      var isCust = d.pvKind === 'customer';
      var ratio = parseFloat(d.pvRatio) || 1;

      dlg.classList.toggle('btr-pv-player--customer', isCust);
      dlg.classList.toggle('btr-pv-player--wide', ratio > 1.2);
      stage.style.setProperty('--pv-ratio', String(ratio));

      badge.textContent = isCust ? 'Customer video' : 'BTR video';
      if (isCust) {
        title.textContent = d.pvName || d.pvTitle;
        var bits = [];
        if (d.pvName) bits.push(d.pvTitle);
        if (d.pvVerified === 'true') bits.push('✓ Verified buyer');
        meta.textContent = bits.join(' · ');
        text.textContent = d.pvQuote ? '“' + d.pvQuote + '”' : '';
        inc.textContent = d.pvIncentive || '';
      } else {
        title.textContent = d.pvTitle;
        meta.textContent = d.vlPlabel || '';
        text.textContent = d.pvDescription || '';
        inc.textContent = '';
      }

      pname.textContent = d.vlPtitle || '';
      price.textContent = d.vlPrice || '';
      shop.href = d.vlUrl || '#';
      if (d.vlImg) { pimg.src = d.vlImg; pimg.hidden = false; } else { pimg.removeAttribute('src'); pimg.hidden = true; }

      dots.innerHTML = '';
      for (var i = 0; i < list.length; i++) {
        var dot = document.createElement('i');
        if (i === n) dot.className = 'is-on';
        dots.appendChild(dot);
      }

      if (tpl) {
        stage.appendChild(tpl.content.cloneNode(true));
        var v = stage.querySelector('video');
        if (v) {
          v.setAttribute('playsinline', '');
          v.preload = 'auto';
          var p = v.play();
          if (p && p.catch) p.catch(function () { v.muted = true; v.play().catch(function () {}); });
        }
      }
      track('btr_video_play', { video_title: d.pvTitle, made_by: isCust ? 'customer' : 'btr', product: d.vlPlabel, page: 'library' });
    }

    function open(card, from) {
      list = visibleCards();
      var n = list.indexOf(card);
      if (n === -1) { list = items.map(function (it) { return it.querySelector('[data-pv-card]'); }); n = list.indexOf(card); }
      if (n === -1) return;
      opener = from || document.activeElement;
      dlg.classList.toggle('btr-pv-player--single', list.length < 2);
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.classList.add('btr-pv-lock');
      show(n);
    }

    function close() {
      stopVideo();
      if (dlg.open) { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
    }

    dlg.addEventListener('close', function () {
      stopVideo();
      document.documentElement.classList.remove('btr-pv-lock');
      if (opener && opener.focus) opener.focus();
    });

    items.forEach(function (it) {
      var card = it.querySelector('[data-pv-card]');
      card.addEventListener('click', function () { open(card, card); });
    });

    // Featured video and question chips open a video by its handle.
    Array.prototype.forEach.call(root.querySelectorAll('[data-vl-open]'), function (b) {
      b.addEventListener('click', function () {
        var card = root.querySelector('[data-pv-card][data-vl-handle="' + b.getAttribute('data-vl-open') + '"]');
        if (!card) return;
        if (b.classList.contains('btr-vl__q')) track('btr_video_question', { question: b.textContent.trim() });
        open(card, b);
      });
    });

    dlg.querySelector('.btr-pv-player__close').addEventListener('click', close);
    dlg.querySelector('.btr-pv-player__nav--prev').addEventListener('click', function () { show(current - 1); });
    dlg.querySelector('.btr-pv-player__nav--next').addEventListener('click', function () { show(current + 1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('keydown', function (e) {
      if (list.length < 2) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
    });

    var sx = null, sy = null;
    dlg.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    dlg.addEventListener('touchend', function (e) {
      if (sx === null || list.length < 2) return;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      sx = sy = null;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) show(current + (dx < 0 ? 1 : -1));
    }, { passive: true });

    shop.addEventListener('click', function () {
      var d = list[current] ? list[current].dataset : {};
      track('btr_video_shop_click', { video_title: d.pvTitle, product: d.vlPlabel });
    });

    var invite = root.querySelector('[data-btr-video-invite]');
    if (invite) invite.addEventListener('click', function () { track('btr_video_invite', { link: invite.getAttribute('href'), page: 'library' }); });

    // /pages/videos#bike-cover opens filtered to that shelf (product pages can link like this).
    var hash = (location.hash || '').slice(1);
    var hashTile = hash && tiles.filter(function (t) { return t.getAttribute('data-vl-filter') === hash && !t.hidden; })[0];
    if (hashTile) { setShelf(hash, false); setTimeout(scrollToResults, 60); } else apply();
    window.addEventListener('hashchange', function () {
      var h = (location.hash || '').slice(1);
      var t = h && tiles.filter(function (x) { return x.getAttribute('data-vl-filter') === h && !x.hidden; })[0];
      if (t) { setShelf(h, false); scrollToResults(); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
